import { get } from "lodash";
import { DEFAULT_MAX_INSTANCES } from "@searchui-searchforms/shared/constants";
import { useFormStore } from "@/widgets/classic-form/form";
import type { EventFieldset } from "@/entities/form-metadata";
import { getRowInstancesPaths } from "@/entities/form-metadata";

interface UseIsNewEventEnabledProps {
    fieldset: EventFieldset;
}

// Adding a row appends to every entry it touches, so the fullest entry decides whether it's barred.
export const useIsNewEventEnabled = ({ fieldset }: UseIsNewEventEnabledProps) =>
    useFormStore(({ values }) => {
        const instanceCounts = getRowInstancesPaths(fieldset).map(
            (path) => (get(values, path, []) as unknown[]).length,
        );
        if (instanceCounts.length === 0) return false;

        return Math.max(...instanceCounts) >= (fieldset.maxInstances ?? DEFAULT_MAX_INSTANCES);
    });
